import { create } from 'zustand'

import { MaxReportListItem } from '../services/max-report.service'

type MaxReportStoreState = {
  reportsByConversation: Record<string, MaxReportListItem[]>
  loadingByConversation: Record<string, boolean>
  errorByConversation: Record<string, string | null>
}

type MaxReportStoreActions = {
  setReports: (conversationId: string, reports: MaxReportListItem[]) => void
  setLoading: (conversationId: string, value: boolean) => void
  setError: (conversationId: string, error: string | null) => void
  clearConversation: (conversationId: string) => void
  clearAll: () => void
}

type MaxReportStore = MaxReportStoreState & MaxReportStoreActions

const useMaxReportStore = create<MaxReportStore>((set) => ({
  reportsByConversation: {},
  loadingByConversation: {},
  errorByConversation: {},

  setReports: (conversationId, reports) =>
    set((state) => ({
      reportsByConversation: {
        ...state.reportsByConversation,
        [conversationId]: reports,
      },
    })),

  setLoading: (conversationId, value) =>
    set((state) => ({
      loadingByConversation: {
        ...state.loadingByConversation,
        [conversationId]: value,
      },
    })),

  setError: (conversationId, error) =>
    set((state) => ({
      errorByConversation: {
        ...state.errorByConversation,
        [conversationId]: error,
      },
    })),

  clearConversation: (conversationId) =>
    set((state) => {
      const nextReports = { ...state.reportsByConversation }
      const nextLoading = { ...state.loadingByConversation }
      const nextErrors = { ...state.errorByConversation }

      delete nextReports[conversationId]
      delete nextLoading[conversationId]
      delete nextErrors[conversationId]

      return {
        reportsByConversation: nextReports,
        loadingByConversation: nextLoading,
        errorByConversation: nextErrors,
      }
    }),

  clearAll: () =>
    set({
      reportsByConversation: {},
      loadingByConversation: {},
      errorByConversation: {},
    }),
}))

export default useMaxReportStore
